import { createRouter, createWebHistory } from 'vue-router'
import useUserStore from '@/stores/user.js'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/TableauDeBordPage.vue'),
    meta: {
      mustBeAuthenticated: true
    }
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('../views/CategoriePage.vue'),
    meta: {
      mustBeAuthenticated: true
    }
  },
  {
    path: '/recurrences',
    name: 'recurrences',
    component: () => import('../views/RecurrencePage.vue'),
    meta: {
      mustBeAuthenticated: true
    }
  },
  {
    path: '/compte',
    name: 'compte',
    component: () => import('../views/ComptePage.vue'),
    meta: {
      mustBeAuthenticated: true
    }
  },
  {
    path: '/details-categorie/:id',
    name: 'details-categorie',
    component: () => import('../views/DetailsCategoriePage.vue'),
    meta: {
      mustBeAuthenticated: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginPage.vue'),
    meta: {
      mustBeUnauthenticated: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'home' }
  },
  {
    path: '/:catchAll(.*)*',
    redirect: { name: 'home' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const userStore = useUserStore()

  // Si l'utilisateur est connecté et essaie d'accéder à login
  if (to.meta.mustBeUnauthenticated && userStore.isLogged) {
    // Vérifier s'il y a une route sauvegardée après login
    const afterLoginRoute = window.localStorage.getItem('afterLoginRoute')
    if (afterLoginRoute) {
      const savedRoute = JSON.parse(afterLoginRoute)
      window.localStorage.removeItem('afterLoginRoute')
      return next(savedRoute)
    }
    return next({ name: 'home' })
  }

  // Si la route nécessite l'authentification et l'utilisateur n'est pas connecté
  if (to.meta.mustBeAuthenticated && !userStore.isLogged) {
    // Sauvegarder la route demandée (sauf si c'est login)
    if (to.name !== 'login') {
      window.localStorage.setItem(
        'afterLoginRoute',
        JSON.stringify({
          name: to.name,
          params: to.params,
          query: to.query
        })
      )
    }
    return next({ name: 'login' })
  }

  next()
})

export default router
